import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { ScheduleSteps } from 'src/Components/PrimaryScheduleTabs'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType } from 'src/Types/ui'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'
import { AdCampaignVisualTypeEnum } from 'src/Redux/ad-campaignApi'

import { AdsAdSettingsProps } from '../AdsAdSettings'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const ContainerWithError = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`

const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const VisualName = styled(SubTitle)`
  font-weight: 400;
`

interface AddVisualModalControlsProps {
  visualType: AdsAdSettingsProps['visualType']
}

export const AddVisualModalControls: FC<AddVisualModalControlsProps> = ({
  visualType,
}) => {
  const { setSearch } = useCustomSearchParams()

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.AdVisual,
    }
    setSearch(query)
  }

  if (!visualType) {
    return (
      <AddParameterButton onClick={handleClick}>
        <span>Add visual setup</span>
      </AddParameterButton>
    )
  }

  const visualName =
    visualType === AdCampaignVisualTypeEnum.AI
      ? 'AI-powered visuals'
      : 'Let our experts create visuals'

  return (
    <Container>
      <ContainerWithError>
        <Wrapper>
          <SubTitle>Add visual setup</SubTitle>
          <VisualName translate='no'>{visualName}</VisualName>
        </Wrapper>
        <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
      </ContainerWithError>
    </Container>
  )
}
